<template>
  <page-section title="Collaborations">
    <div class="row">
      <div class="col-xs-12">
        <p text="justify">
          L'équipe SPIADI a pour objectif de développer des collaborations actives
          avec d'autres réseaux et des équipes de recherche dans le champ de la
          surveillance et de la prévention des infections associées aux dispositifs
          intra-vasculaires et à la ventilation mécanique.
        </p>
        <p text="justify">
          Dans le cadre de nos missions, nous pilotons des études multicentriques
          annuelles avec les objectifs :
        </p>
        <ul>
          <li>
            de produire des données épidémiologiques,
          </li>
          <li>
            d'améliorer la compréhension des mécanismes de la survenue des
            infections associées aux dispositifs invasifs,
          </li>
          <li>
            d'étudier l'impact de solutions innovantes en matière de prévention.
          </li>
        </ul>
      </div>
    </div>
  </page-section>
</template>
<script>
import pageSection from '@/components/pagesection'

export default {
  name: 'collaborations',

  data () {
    return {
    }
  },
  components: {
    'page-section': pageSection
  }
}
</script>
